// Remembers where the user is (shell view / open tool / open TKNE project) so a
// page refresh lands back on the same screen instead of the main screen.
// Web reads synchronously from localStorage so the first render is already
// the right screen (no flash of home); native restores via AsyncStorage.
import { Platform } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';

const PREFIX = 'olmps.nav.';

export function readNavSync<T>(key: string): T | null {
  if (Platform.OS !== 'web') return null;
  try {
    const raw = window.localStorage.getItem(PREFIX + key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}

export async function readNav<T>(key: string): Promise<T | null> {
  if (Platform.OS === 'web') return readNavSync<T>(key);
  try {
    const raw = await AsyncStorage.getItem(PREFIX + key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}

export function writeNav(key: string, value: unknown): void {
  const raw = JSON.stringify(value ?? null);
  try {
    if (Platform.OS === 'web') window.localStorage.setItem(PREFIX + key, raw);
    else void AsyncStorage.setItem(PREFIX + key, raw).catch(() => {});
  } catch {
    /* best-effort */
  }
}
